import { render, staticRenderFns } from "./VueDatePicker.vue?vue&type=template&id=45c86adc&"
import script from "./VueDatePicker.vue?vue&type=script&lang=ts&"
export * from "./VueDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./VueDatePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports